import { TranslateService } from "@ngx-translate/core";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ValidationContext } from "~app/common/validation/validationContext";
import { KundorderDetailRequestDTO } from "../models/KundorderDetailRequestDTO";

export class KundorderValidation {
    static init(
        translateService: TranslateService,
        kundorder: KundorderDetailRequestDTO): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.skapa).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                message: { text: translateService.instant("KUNDORDER_DETAIL_KUND_VALIDATION") },
                model: () => kundorder.kund,
                name: "kund",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 2,
                message: { text: "Du måste ange måttslag" },
                model: () => kundorder.mattslag,
                name: "mattslag",
                required: true
            }
        ]);
        return context;
    }
}
